import {
  getQuotation,
  getSecondCoownerData,
} from 'app/services/businessFunctionHelpers';
import { handleOnChangeDataSecondCoOwnerRenewal } from './helpers';
import { checkHasDataChangedForRenewal } from 'app/services/businessFunctions/helpers/checkHasDataChangedForRenewal';

const onSecondCoownerNameChange = {
  onSecondCoownerNameChange(initialRun?: boolean) {
    const { name } = getSecondCoownerData();
    const { coOwners } = getQuotation();

    const previousName = coOwners?.[1]?.name || '';

    if (checkHasDataChangedForRenewal(name, previousName)) {
      handleOnChangeDataSecondCoOwnerRenewal(initialRun);
    }
  },
};

export default onSecondCoownerNameChange;
